export default __webpack_public_path__ + "static/media/logo-white.7f8ab1aa.svg";